import React from 'react'
import { ChangeAccountFormContainer } from '../../containers/SupportSystem/ChangeAccountFormContainer'
export const ChangeAccountFormPage = () => {
    return (
        <ChangeAccountFormContainer />
    )
}
